import React from "react";

import "../styles/search.scss";
import Button from "./layout/button";

export default class SearchNumber extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      value: "",
      error: "",
      showLabel: false,
    };

    this.setValue = this.setValue.bind(this);
    this.setError = this.setError.bind(this);
  }
  
  componentWillUnmount() {
    clearInterval(this.interval);
  }



  render() {
    /**
     * @type {{
     *  onSearch: (value: string) => void
     *  min: number
     *  max: number
     *  onSurpresinha: () => void
     * }}
     */
    const { onSearch, min, max, onSurpresinha } = this.props;
    const { value, error } = this.state;

    /**
     * @param {KeyboardEvent} event
     */
    const handleEnter = ({ key }) => {
      if (key == "Enter") {
        submit();
      }
    };

    const submit = () => {
      if (value != "") {
        const error = this.setError(onSearch(value));
        if (!error) {
          this.setState({
            ...this.state,
            value: "",
            error: null,
          });
        }
      }
    };

    const setSanitizedValue = (v)=> {
      if(v.toString().length <= this.props.max && v >= 0) {
        this.setValue(v);
      }
    }

    const setSurpresinha = () => {
      this.setState({ showLabel: true });

      this.interval = setInterval(() => {
        // Altere o valor do booleano para false após 5 segundos (5000 milissegundos)
        this.setState({ showLabel: false });
        clearInterval(this.interval);
      }, 2000);

      onSurpresinha();
    }

    const addCarrinho = (e) => {
      this.setState({ showLabel: true });

      this.interval = setInterval(() => {
        // Altere o valor do booleano para false após 5 segundos (5000 milissegundos)
        this.setState({ showLabel: false });
        clearInterval(this.interval);
      }, 2000);

      submit(e);
    }

    return (
      <React.Fragment>
        <div className="search-number-rifa">
          <div className="search-number-rifa__input-wrapper">
            <div className="search-number-rifa__input-container">
              <input
                className="search-number-rifa__input"
                type="number"
                placeholder="Escolher um número"
                value={value}
                onChange={(e) => setSanitizedValue(e.target.value)}
                onKeyDown={handleEnter}
              />
              <p className="search-number-rifa__error-text">{error}</p>
              <p className="search-number-rifa__label-text">{this.state.showLabel && 'Adicionado ao carrinho!'}</p>
            </div>
            {value !== "" ?
              <Button
                className="search-number-rifa__button"
                onClick={(e) => addCarrinho(e)}
                disabled={value == ""}
              >
                Adicionar ao Carrinho
              </Button>
              :
              <Button
                className="search-number-rifa__button"
                onClick={() => setSurpresinha()}
              >
                Surpresinha
              </Button>
            }
          </div>
        </div>
      </React.Fragment>
    );
  }

  setValue(newValue) {
    this.setState({
      ...this.state,
      value: newValue,
    });
  }

  setError(newError) {
    this.setState({
      ...this.state,
      error: newError,
    });

    return newError;
  }
}



// WEBPACK FOOTER //
// ./src/rifa/components/search.jsx